import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { Link, Route } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCertificate,
  faCheck,
  faClock,
  faFile,
  faFileContract,
  faCheckCircle,
} from '@fortawesome/free-solid-svg-icons'
import {
  Card,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalHeader,
  ModalBody,
  UncontrolledDropdown,
} from 'reactstrap'
import Tooltip from 'rc-tooltip'
import { getLabelText, getStatusColorReport } from 'utils/helpers'

import {
  setShowCertificate,
  setHideCertificate,
} from 'store/EmployeeReport/actions'

import {
  getUserStores,
  getReport,
  getExemptCourses,
  setSearchValue,
  onChange as onChangeText,
  resetProgress,
  setExemptCourses,
  markQuizPassed,
  clearAttempt,
  removeExemptCourse,
  toggleReasonOverlay,
  setShowSubmissionData,
  exemptCourse as exemptCourseRedux,
  getEmployeeLibrary,
  toggleDropdown,
  selectTab,
  markCompleted,
  setHideSubmissionData,
} from 'store/EmployeeReport/actions'
import * as checklistActions from 'store/Checklist/actions'
import { fetchUsers } from 'store/Users/actions'

import Checklist from '../Checklist'
import UserAvatar from '../../../assets/img/default_avatar.png'
import Loader from '../Loader'
import Certificate from '../Certificate'
import Search from '../Search'
import Submission from '../Submission'
import TextEditor from '../TextEditor'
import './styles/styles.css'
import './styles/newStyles.css'

// Global Css Leon
import '../../../assets/css/Global/style.css'
import { isTextEmpty } from 'utils/helpers'
import { millisecondsToHoursMinutes } from 'utils/helpers'

const ChecklistButton = (props) => {
  const language = props.language

  return (
    <Link
      size='sm'
      title={language?.manager_report.view_checklist}
      to={`/manager-reports/employee/${props.userId}/checklist?course_id=${props.course_id}`}
    >
      <button className='btn btn-info employee-button'>
        {props.status === 4
          ? language?.manager_report.view_checklist
          : language?.manager_report.checklist}
      </button>
    </Link>
  )
}

const AgreementStatus = ({ item, courseConfig, language }) => {
  const [showAgreement, setShowAgreement] = useState(false)

  if (
    item.status !== 4 ||
    item.require_agreement !== 1 ||
    item.terms_agreed !== 1
  ) {
    return null
  }

  return (
    <>
      <div
        className='agreement-status-indicator'
        onClick={() => setShowAgreement(true)}
        style={{
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          padding: '2px 6px',
          fontSize: '11px',
          color: '#28a745',
          backgroundColor: '#d4edda',
          border: '1px solid #c3e6cb',
          borderRadius: '3px',
          marginLeft: '8px',
        }}
        title='Click to view agreement terms'
      >
        <FontAwesomeIcon
          icon={faFileContract}
          style={{ fontSize: '10px', marginRight: '4px' }}
        />
        <span>Terms Agreed</span>
      </div>

      <Modal
        isOpen={showAgreement}
        toggle={() => setShowAgreement(false)}
        size='lg'
        centered
      >
        <ModalHeader toggle={() => setShowAgreement(false)}>
          Course Certification Agreement
        </ModalHeader>
        <ModalBody>
          <div className='mb-3'>
            <strong>Course:</strong> {item.name}
          </div>
          <div className='mb-3'>
            <div
              dangerouslySetInnerHTML={{
                __html:
                  courseConfig.agreementContent ||
                  'No agreement content available.',
              }}
            />
          </div>
          <div className='alert alert-success d-flex align-items-center'>
            <FontAwesomeIcon
              icon={faCheckCircle}
              style={{ marginRight: '8px', color: '#28a745' }}
            />
            <span>
              <strong>Status:</strong> User agreed to these terms during
              certification on{' '}
              {item.certify_time
                ? moment(item.certify_time).format('YYYY-MM-DD HH:mm')
                : 'certification'}
            </span>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

const CertificatetButton = (props) => {
  const dispatch = useDispatch()
  return (
    <FontAwesomeIcon
      title='View / Print certificate'
      onClick={() => dispatch(setShowCertificate(props.course))}
      icon={faCertificate}
      style={{
        color: 'gold',
        fontSize: '20px',
        marginLeft: '10px',
        cursor: 'pointer',
      }}
    />
  )
}

const User = (props) => {
  const language = props.language

  return (
    <div className='leon gap1'>
      <div className='cardHeaderProfile col2 md-col3'>
        <img
          src={props.avatar ? props.avatar.url : UserAvatar}
          alt='User'
          style={{ objectFit: 'cover' }}
        />
      </div>
      <div className='dFlex flexCol justifyBetween col10 md-col9'>
        <h2 className='cardHeaderName'>
          {props.first_name} {props.last_name}
        </h2>
        <p className='cardHeaderRole'>{props.roles}</p>
        <div className='dFlex gap1 itemsCenter'>
          {props.manager &&
            (props.manager.access === 1 ||
              props.manager.access === 4 ||
              props.manager.access === 5 ||
              [2, 3].includes(props.access)) && (
              // || (props.access === 3
              //  (courseConfig.userCourseManagerCanEditUser === 1 &&
              // ) && (
              <Link
                className='cardHeaderButton'
                to={`/settings/users/${props.id}/?emp_report`}
              >
                {language?.manager_report.edit_user}
              </Link>
            )}
          {props.id && (
            <Link
              className='cardHeaderButton'
              onClick={(e) => {
                e.preventDefault()
                PrintElem(
                  'topic-body-content',
                  props.first_name + ' ' + props.last_name,
                )
              }}
            >
              Print
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

function PrintElem(elem, title) {
  var mywindow = window.open('', 'PRINT')

  const styleTemplate = `<style>
	.tab-items,
	.course-to-be-graded .small-dropdown,
	.grade-status-wrapper .btn-checklist {
		display: none !important;
	}
	.course-to-be-graded,
	.grade-status-wrapper {
		margin: 0 !important;
	}

	.grade-status-wrapper svg {
		font-size: 20px !important;
		width: 20px !important;
		height: 20px !important;
		float: right;
	}
	
	.grade-status .certify-time {
		font-size: 14px;
		margin-top: 5px;
	}

	.btn-print b,
	.btn-print {
		font-size: 0.75rem;
		color: #03606d;
	}
	.report-progress-bar {
		margin-top: 1.5rem;
		min-width: 20px;
	}
	.progress-bar-wrapper-user {
		height: 1rem;
		border-radius: 0.9375rem;
		background: #e1e1e1;
		margin: 1.25rem 0;
		position: relative;
	}
	.report-progress-bar .progress-bar {
		height: inherit;
		border-radius: 0.9375rem;
		background: #7cd4e1;
		text-align: center;
		position: relative;
		transition: width 0.5s;
	}
	.report-progress-bar .progress-bar span {
		color: #03606d;
		font-size: 11px;
		font-weight: 600;
	}
	.courses-completed {
		position: absolute;
		bottom: -19px;
		right: 0;
	}
	.courses-completed-percentage {
		line-height: 1rem;
		position: absolute;
		top: 0;
		padding-left: 5px;
	}
	.courses-total {
		color: #03606d;
		font-size: 11px;
		font-weight: 600;
		position: absolute;
		bottom: -19px;
		right: 4px;
	}
	.courses-to-be-graded-wrapper {
		margin-bottom: 2rem;
	}
	.course-to-be-graded {
		margin: 0.875rem 0;
		/* border: 1px solid tomato; */
	}
	.course-to-be-graded h4 {
		font-weight: 300;
		display: inline-block;
	}
	.open-dropdown {
		padding: 3px 10px;
		margin-left: 10px;
	}
	.small-dropdown {
		display: inline-block;
		vertical-align: top;
		position: relative;
	}
	.small-dropdown-content {
		width: 170px;
		padding: 10px;
		position: absolute;
		top: 30px;
		left: 0;
	}
	.small-dropdown-content a {
		font-weight: 300;
		display: block;
		padding: 3px 5px;
		color: #03606d;
	}
	.small-dropdown-content li {
		cursor: pointer;
		padding: 10px 5px;
	}
	.small-dropdown-content li:first {
		padding-top: 0;
	}
	.small-dropdown-content li:hover {
		background: #f5f5f5;
	}
	.grade-status-wrapper {
		margin: 0.875rem 0;
		text-align: right;
	}
	.grade-status-wrapper span {
		font-weight: 300;
	}
	.individual-course-progressbar {
		background: #e1e1e1;
		height: 5px;
	}
	.individual-course-progress {
		height: inherit;
		background: #7cd4e1;
		transition: width 0.5s;
	}
	.grade-status-wrapper .grade-status {
		font-weight: 600;
	}
	.quiz-title,
	.quiz-status {
		margin: 0.875rem 0;
	}
	.quiz-status {
		text-align: right;
	}

	.cursor-default {
		cursor: default !important;
	}

	.checklist-completed-label {
		font-size: 16px;
		font-weight: 600;
		color: #4caf50;
		margin-left: 7px;
	}
	.btn-checklist {
		margin-left: 15px;
	}

	.d-green-label,
	.d-green-label b {
		font-size: 12px;
		color: #03606d;
	}
	.default-search-input-wrapper input[type='text'] {
		width: 100%;
		display: inline-block;
		vertical-align: middle;
		padding: 6px 5px;
		background-color: #f1f1f1;
		border: none;
	}
	.search-report-courses {
		margin-right: 10px;
	}
	.default-search-input-wrapper input.light {
		background: #fff;
	}
	.past-due-status {
		color: tomato;
	}
	.topic-user-edit {
		color: #006394;
		font-size: 13px;
		font-weight: 600;
		text-decoration: underline;
		border: none;
		cursor: pointer;
		background: none;
	}

	.settings-tabs {
		padding: 5px;
		border-bottom: none;
		margin-bottom: 15px;
		max-width: fit-content;
		/* max-width: 100%; */
		font-weight: 600;
		transition: all 0.4s ease-in-out;
		background-color: #f6f9fc;
	}
	
	.settings-tabs span {
		padding: 10px 34px;
		font-size: 0.875rem;
		color: #8889aa;
		transition: all 0.4s ease-in-out;
		cursor: pointer;
	}
	
	.settings-tabs .current {
		background: #fff;
		color: #48495a;
		font-weight: 600;
		transition: all 0.4s ease-in-out;
		border-radius: 5px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
	.settings-tabs a {
		padding: 12px 15px;
		font-size: 0.875rem;
		color: #8889aa;
		transition: all 0.4s ease-in-out;
		cursor: pointer;
	}
	
	.settings-tabs a:hover {
		color: #333;
	}
	

	.search-wrapper {
		padding: 0;
		margin: 0;
		position: relative;
		/* margin-top: 12px; */
	}
	.search-wrapper input[type='text'] {
		display: block;
		width: 100%;
		height: 36px;
		padding: 6px 74px 6px 10px;
		color: #aaa;
		border: 1px solid #ccc;
		border-radius: 2px;
	}

	.search-wrapper input::placeholder {
		/* color: red; */
		font-size: 13.5px;
	}

	.search-submit {
		width: 70px;
		height: 36px;
		background: #5bc0de;
		border: 0;
		border-radius: 0 2px 2px 0;
		position: absolute;
		top: 0;
		right: 0;
		font-size: 12px;
		color: #fff;
		cursor: pointer;
	}

	.m-top-12 {
		margin-top: 12px;
	}

	@-ms-viewport {
		width: device-width;
	}
	html {
		box-sizing: border-box;
		-ms-overflow-style: scrollbar;
	}

	*,
	*::before,
	*::after {
		box-sizing: inherit;
	}

	.container {
		margin-right: auto;
		margin-left: auto;
		padding-right: 15px;
		padding-left: 15px;
		width: 100%;
	}

	.container-fluid {
		width: 100%;
		margin-right: auto;
		margin-left: auto;
		padding-right: 15px;
		padding-left: 15px;
		width: 100%;
	}

	.row {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		margin-right: -15px;
		margin-left: -15px;
	}

	.no-gutters {
		margin-right: 0;
		margin-left: 0;
	}
	.no-gutters > .col,
	.no-gutters > [class*='col-'] {
		padding-right: 0;
		padding-left: 0;
	}

	.col-1,
	.col-2,
	.col-3,
	.col-4,
	.col-5,
	.col-6,
	.col-7,
	.col-8,
	.col-9,
	.col-10,
	.col-11,
	.col-12,
	.col,
	.col-auto,
	.col-sm-1,
	.col-sm-2,
	.col-sm-3,
	.col-sm-4,
	.col-sm-5,
	.col-sm-6,
	.col-sm-7,
	.col-sm-8,
	.col-sm-9,
	.col-sm-10,
	.col-sm-11,
	.col-sm-12,
	.col-sm,
	.col-sm-auto,
	.col-md-1,
	.col-md-2,
	.col-md-3,
	.col-md-4,
	.col-md-5,
	.col-md-6,
	.col-md-7,
	.col-md-8,
	.col-md-9,
	.col-md-10,
	.col-md-11,
	.col-md-12,
	.col-md,
	.col-md-auto,
	.col-lg-1,
	.col-lg-2,
	.col-lg-3,
	.col-lg-4,
	.col-lg-5,
	.col-lg-6,
	.col-lg-7,
	.col-lg-8,
	.col-lg-9,
	.col-lg-10,
	.col-lg-11,
	.col-lg-12,
	.col-lg,
	.col-lg-auto,
	.col-xl-1,
	.col-xl-2,
	.col-xl-3,
	.col-xl-4,
	.col-xl-5,
	.col-xl-6,
	.col-xl-7,
	.col-xl-8,
	.col-xl-9,
	.col-xl-10,
	.col-xl-11,
	.col-xl-12,
	.col-xl,
	.col-xl-auto {
		position: relative;
		width: 100%;
		min-height: 1px;
		padding-right: 15px;
		padding-left: 15px;
	}

	.col {
		-ms-flex-preferred-size: 0;
		flex-basis: 0;
		-webkit-box-flex: 1;
		-ms-flex-positive: 1;
		flex-grow: 1;
		max-width: 100%;
	}

	.col-auto {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 auto;
		flex: 0 0 auto;
		width: auto;
		max-width: none;
	}

	.col-1 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 8.33333%;
		flex: 0 0 8.33333%;
		max-width: 8.33333%;
	}

	.col-2 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 16.66667%;
		flex: 0 0 16.66667%;
		max-width: 16.66667%;
	}

	.col-3 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 25%;
		flex: 0 0 25%;
		max-width: 25%;
	}

	.col-4 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 33.33333%;
		flex: 0 0 33.33333%;
		max-width: 33.33333%;
	}

	.col-5 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 41.66667%;
		flex: 0 0 41.66667%;
		max-width: 41.66667%;
	}

	.col-6 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 50%;
		flex: 0 0 50%;
		max-width: 50%;
	}

	.col-7 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 58.33333%;
		flex: 0 0 58.33333%;
		max-width: 58.33333%;
	}

	.col-8 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 66.66667%;
		flex: 0 0 66.66667%;
		max-width: 66.66667%;
	}

	.col-9 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 75%;
		flex: 0 0 75%;
		max-width: 75%;
	}

	.col-10 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 83.33333%;
		flex: 0 0 83.33333%;
		max-width: 83.33333%;
	}

	.col-11 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 91.66667%;
		flex: 0 0 91.66667%;
		max-width: 91.66667%;
	}

	.col-12 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
	}

	.body__settings--tab{
		display: none;
	}

	* {
		margin: 0;
		padding: 0;
		font-family: 'Open Sans', sans-serif;
		text-decoration: none;
		font-size: 16px;
	}
	html {
		height: 100%;
	}
	body {
		height: 100%;
		background-attachment: fixed;
		background-size: cover;
		background-color: #fff;
		background-repeat: no-repeat;
		/* background-image:url(../images/body_bg.jpg); */
	}
	</style>`

  mywindow.document.write('<html><head><title>' + title + '</title>')
  mywindow.document.write(styleTemplate)
  mywindow.document.write('</head><body >')
  mywindow.document.write('<h1 style="margin-bottom:20px;">' + title + '</h1>')
  mywindow.document.write(document.getElementsByClassName(elem)[0].outerHTML)
  mywindow.document.write('</body></html>')

  mywindow.document.close() // necessary for IE >= 10
  mywindow.focus() // necessary for IE >= 10*/

  mywindow.print()
  mywindow.close()

  return true
}

const Dropdown = (props) => {
  const dispatch = useDispatch()
  const language = props.language

  const currentCourse = props.progress.find(
    (item) => item.course_id === props.course_id,
  )

  const showViewSubmission = () => {
    dispatch(setShowSubmissionData(currentCourse.id))
  }

  const exemptCourse = props.exemptCourses.find(
    (exemptCourse) => exemptCourse.course_id === currentCourse.course_id,
  )

  return (
    <UncontrolledDropdown>
      <DropdownToggle
        className='btn-icon-only text-light ml-1'
        // style={{ display: props.isShowing ? "" : "none", zIndex: 1 }}
        role='button'
        size='sm'
        color=''
        onClick={(e) => {
          e.stopPropagation()
          dispatch(toggleDropdown(props.id))
        }}
      >
        <i className='fas fa-ellipsis-v' />
      </DropdownToggle>
      <DropdownMenu className='dropdown-menu-arrow' left>
        {props.status < 1 &&
        !currentCourse.isExempt &&
        !exemptCourse &&
        (props.user.access === 1 || props.user.access === 2) ? (
          // courseConfig.userAdminMarkCourseComplete !== 1)
          <DropdownItem
            onClick={(e) => {
              e.preventDefault()
              dispatch(markCompleted())
            }}
          >
            {language?.manager_report.mark_completed}
          </DropdownItem>
        ) : null}
        {props.status < 2 &&
        props.has_quiz &&
        !currentCourse.isExempt &&
        !exemptCourse &&
        (props.user.access === 1 || props.user.access === 2) ? (
          //   courseConfig.userAdminMarkQuizPassed !== 1) ? (
          <DropdownItem onClick={() => dispatch(markQuizPassed())}>
            {language?.manager_report.mark_quiz_passed}
          </DropdownItem>
        ) : props.status >= 1 ? (
          <DropdownItem onClick={() => dispatch(clearAttempt())}>
            {language?.manager_report.clear_attempt}
          </DropdownItem>
        ) : null}
        {currentCourse &&
        !currentCourse.isExempt &&
        !exemptCourse &&
        [1, 2].includes(props.user.access) ? (
          <DropdownItem
            onClick={() => {
              dispatch(toggleReasonOverlay(currentCourse))
              props.setModalHandler(true)
            }}
          >
            {language?.manager_report.exempt_course}
          </DropdownItem>
        ) : null}
        {currentCourse.isExempt ||
        (exemptCourse && [1, 2, 4, 5].includes(props.user.access)) ? (
          <DropdownItem
            onClick={() => dispatch(removeExemptCourse(currentCourse))}
          >
            Remove Exempt
          </DropdownItem>
        ) : null}
        {props.has_submission ? (
          JSON.parse(props.quiz) &&
          JSON.parse(props.quiz).questions &&
          JSON.parse(props.quiz).questions.length ? (
            <DropdownItem onClick={() => showViewSubmission()}>
              {language.courses ? language?.courses.view_submission : null}
            </DropdownItem>
          ) : null
        ) : null}
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

const ExemptReason = (props) => {
  const dispatch = useDispatch()
  const language = props.language

  const exemptCourse = props.exemptCourses.find(
    (exemptCourse) => exemptCourse.course_id === props.currentSelectedCourse.id,
  )

  // const isExempt = props.currentSelectedCourse.isExempt
  //   ? props.currentSelectedCourse.isExempt
  //   : false

  const handleToggle = () => {
    dispatch(toggleReasonOverlay())
  }
  return (
    <Modal
      isOpen={props.isShowing}
      toggle={handleToggle}
      size={'md'}
      centered
      height={true}
      keyboard={true}
      fade={false}
    >
      <ModalHeader className='border-bottom pb-1' toggle={handleToggle}>
        Exempt reason
      </ModalHeader>
      <div className='exempt-form-container scrollbar'>
        <form
          className='exempt-form'
          onSubmit={() => dispatch(props.saveReasonMessage())}
        >
          <div className='text-editor'>
            <TextEditor
              activeClass='p10'
              style={{ minHeight: '250px' }}
              textContent={exemptCourse ? exemptCourse.message : props.message}
              onChangeText={(e) => dispatch(onChangeText(e))}
              autoFocus
              placeholder={language?.manager_report.specify_reason}
              disable={exemptCourse ? true : false}
              className='exempt-textarea prova'
              setOptions={
                !exemptCourse
                  ? {
                      buttonList: [
                        ['undo', 'redo', 'list', 'fontColor'],
                        ['bold', 'underline', 'italic'],
                        ['link'],
                      ],
                    }
                  : { buttonList: [] }
              }
            />
          </div>

          {!exemptCourse ? (
            <div className='p-1 py-3 text-right mr-1'>
              <button
                className='btn btn-info employee-button'
                onClick={(e) => {
                  dispatch(exemptCourseRedux(e))
                }}
              >
                {language?.manager_report.save_message}
              </button>
            </div>
          ) : (
            <span className='exempt-info'>
              {/* {language?.manager_report.exempt +
								moment(props.currentSelectedCourse.exemptDate).format(
									'MM/DD/YYYY, h:mm a'
								) +
								' by ' +
								props.currentSelectedCourse.exemptBy.manager.first_name +
								' ' +
								props.currentSelectedCourse.exemptBy.manager.last_name} */}
              exempt
            </span>
          )}
        </form>
      </div>
    </Modal>
  )
}

const Progress = (props) => {
  const language = props.language

  return (
    <div className='report-progress-bar'>
      <h4>{language?.settings.courses}</h4>
      {(() => {
        const filteredProgress = props.progress.filter((item) =>
          props.selectedEmployeeTab === 'active'
            ? item.is_active === 1
            : item.is_active === -1,
        )
        const courseLen = filteredProgress.length
        const completed = filteredProgress.filter(
          (item) => item.status === 4,
        ).length
        const total = (completed / courseLen) * 100
        const percent = !completed
          ? 0
          : Number.isInteger(total)
            ? total
            : total.toFixed(2)

        const totalMs = filteredProgress.reduce(
          (sum, item) => sum + (item.certification_time || 0),
          0,
        )
        const timeSpent = millisecondsToHoursMinutes(totalMs)

        return (
          <>
            <div className='progress-bar-wrapper-user'>
              <div
                className='progress-bar'
                role='progressbar'
                aria-valuenow='60'
                aria-valuemin='0'
                aria-valuemax='100'
                style={{ width: `${percent}%` }}
              >
                <span className='cardHeaderEmployeeReport'>{percent}%</span>
              </div>
            </div>
            {totalMs > 0 && (
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  marginTop: '10px',
                  padding: '4px 12px',
                  backgroundColor: '#e8f7f9',
                  border: '1px solid #7cd4e1',
                  borderRadius: '20px',
                  fontSize: '12px',
                  fontWeight: '600',
                  color: '#03606d',
                }}
              >
                <FontAwesomeIcon icon={faClock} style={{ fontSize: '11px' }} />
                <span>{timeSpent} total</span>
              </div>
            )}
          </>
        )
      })()}
    </div>
  )
}

const HomeworkTab = (props) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getEmployeeLibrary(props.user.id))
  }, [dispatch, props.user.id])

  return (
    props.employeeLibrary &&
    props.employeeLibrary.map((file) => (
      <div style={{ display: 'flex' }} key={file.id}>
        <div className='col-12'>
          <div className='justify-content'>
            <a href={file.path} target='_blank' rel='noreferrer'>
              <div className='roles-list-wrapper'>
                <div className='rewards-row'>
                  {file.thumb ? (
                    <img
                      width='40'
                      height='40'
                      src={file.thumb}
                      style={{ display: 'inline-block' }}
                      alt='file'
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faFile}
                      style={{ fontSize: '40px', color: '#5bc0de' }}
                    />
                  )}
                  <p> {file.name || ''} </p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    ))
  )
}
// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const dispatch = useDispatch()
  const employeeReport = useSelector((state) => state.employeeReport)
  const user = useSelector((state) => state.auth.user)
  const users = useSelector((state) => state.users)
  const courseConfig = useSelector((state) => state.courseConfig)
  const [modal, setModal] = useState(false)
  const [employeeReportProgress, setEmployeeReportProgress] = useState(
    employeeReport.progress,
  )
  const checklist = useSelector((state) => state.checklist)

  const theme = useSelector((state) => state.themeConfig.theme)

  const setModalHandler = (isOpen) => {
    setModal(isOpen)
  }

  useEffect(() => {
    dispatch(getReport(props.match.params.userId))
    dispatch(getUserStores(props.match.params.userId))
    dispatch(selectTab('active'))
    dispatch(getExemptCourses(props.match.params.userId))

    if (!users.users.length) {
      dispatch(fetchUsers())
    }
    return () => {
      dispatch(resetProgress())
    }
  }, [props.match.params.userId, dispatch])

  useEffect(() => {
    if (employeeReport.progress.length !== employeeReportProgress.length) {
      if (employeeReport.exemptCourses.length !== 0) {
        dispatch(setExemptCourses())
        setEmployeeReportProgress(employeeReport.progress)
      }
    }
  }, [
    dispatch,
    employeeReport.exemptCourses,
    employeeReport.progress,
    employeeReportProgress,
  ])

  useEffect(() => {
    dispatch(getReport(props.match.params.userId))
  }, [checklist.status])

  const language = useSelector((state) => state.language.language?.data)

  const percentageQuiz = (quizScore, quizSubmission) => {
    // let quizScore = userSubmissions[id] ? userSubmissions[id].quiz_score : 0
    let totalPoints =
      (quizSubmission &&
        quizSubmission.length > 0 &&
        quizSubmission
          .map((item) => parseInt(item.points))
          .reduce((total, value) => total + value)) ||
      0

    let percentage =
      totalPoints !== 0 ? parseInt((quizScore / totalPoints) * 100) : 0
    return percentage
  }

  return (
    <>
      <Container className='mt--6 employee' fluid>
        <div className='col'>
          <Card>
            {employeeReport.isLoading ? (
              <div className='my-5'>
                <Loader />
              </div>
            ) : (
              <Col className='p2'>
                <div>
                  <div className='leon gap2 sm-gapX0'>
                    <div className='col4 xl-col12'>
                      <User
                        {...employeeReport.user}
                        manager={user}
                        language={language}
                        courseConfig={courseConfig}
                      />
                    </div>
                    <div
                      className='dFlex flexCol justifyCenter col8 xl-col12 '
                      // style={{ marginTop: '1.5rem' }}
                    >
                      <div>
                        <div>
                          <div className='dFlex itemsCenter gap3 xs-gap1'>
                            <span className='cardHeaderEmployeeReport'>
                              <FontAwesomeIcon icon={faCheck} />
                              &nbsp;&nbsp;
                              <span>
                                <b>
                                  {language?.manager_report
                                    ? language.manager_report.certified_courses
                                    : null}
                                  :
                                </b>
                                <b>
                                  {
                                    employeeReport.progress.filter((item) =>
                                      employeeReport.selectedEmployeeTab ===
                                      'active'
                                        ? item.status === 4 &&
                                          item.is_active === 1
                                        : item.status === 4 &&
                                          item.is_active === -1,
                                    ).length
                                  }
                                </b>
                              </span>
                            </span>
                            <span className='cardHeaderEmployeeReport'>
                              <b>
                                {language?.manager_report
                                  ? language.manager_report.total_courses
                                  : null}
                                :{' '}
                                {
                                  employeeReport.progress.filter((item) =>
                                    employeeReport.selectedEmployeeTab ===
                                    'active'
                                      ? item.is_active === 1
                                      : item.is_active === -1,
                                  ).length
                                }
                              </b>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          <Progress {...employeeReport} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            )}
          </Card>
          <Card>
            <div className='pt-3 pb-3 topic-body-content'>
              {employeeReport.isLoading ? (
                <div className='loaderHight50 my-5'>
                  <Loader />
                </div>
              ) : (
                <div>
                  {[1].includes(user.access) ? (
                    <div className='body__settings--tab'>
                      <div className='col-xl-9 col-lg-9 col-md-8 col-12 tabs-responsive'>
                        <div className='settings-tabs d-flex gap-10 mb-0 py-1 mb-3'>
                          <span
                            className={`${
                              employeeReport.selectedEmployeeTab === 'active'
                                ? 'current'
                                : null
                            }`}
                            onClick={() => dispatch(selectTab('active'))}
                          >
                            {language?.general.active}
                          </span>

                          <span
                            className={`${
                              employeeReport.selectedEmployeeTab === 'inactive'
                                ? 'current'
                                : null
                            }`}
                            onClick={() => dispatch(selectTab('inactive'))}
                          >
                            {language?.general.inactive}
                          </span>
                          <span
                            className={`${
                              employeeReport.selectedEmployeeTab === 'homework'
                                ? 'current'
                                : null
                            }`}
                            onClick={() => dispatch(selectTab('homework'))}
                          >
                            {language?.my_library
                              ? language.my_library.my_drive
                              : null}
                          </span>
                        </div>
                      </div>
                      <div className='col-xl-3 col-lg-3 col-md-4 col-12'>
                        <Search
                          placeholder={
                            language?.settings
                              ? language.settings.search_courses
                              : null
                          }
                          value={employeeReport.searchValue}
                          onChange={(event) =>
                            dispatch(setSearchValue(event.target.value))
                          }
                        />
                      </div>
                    </div>
                  ) : null}

                  {(employeeReport.selectedEmployeeTab === 'active' ||
                    employeeReport.selectedEmployeeTab === 'inactive') &&
                    employeeReport.progress
                      .filter((item) =>
                        employeeReport.selectedEmployeeTab === 'active'
                          ? item.is_active === 1
                          : item.is_active === -1,
                      )
                      .filter((item) =>
                        employeeReport.searchValue
                          ? item.name &&
                            item.name
                              .toLowerCase()
                              .trim()
                              .indexOf(
                                employeeReport.searchValue.toLowerCase().trim(),
                              ) !== -1
                          : item,
                      )
                      .map((item) => {
                        const isExempt = employeeReport.exemptCourses.find(
                          (exemptCourse) =>
                            exemptCourse.course_id === item.course_id,
                        )
                          ? true
                          : false

                        // const hasStarted = props.userProgress.find(course => course && item.status >= 1) ? true : false
                        const isDropdownEmpty =
                          [2, 4, 5].includes(user.access) && isExempt
                        return (
                          <div className='col mt-5' key={item.id}>
                            <div className='courses-to-be-graded-wrapper'>
                              <div className='d-flex justify-content-between'>
                                <div className='course-to-be-graded d-flex align-items-center'>
                                  <div className='d-flex flex-column'>
                                    <div className='d-flex align-items-center'>
                                      <h4 className='course__name mb-0'>
                                        {item.name}
                                      </h4>
                                      <AgreementStatus
                                        item={item}
                                        courseConfig={courseConfig}
                                        language={language}
                                      />
                                    </div>
                                    {item.certification_time ? (
                                      <small>
                                        Time spent:{' '}
                                        {millisecondsToHoursMinutes(
                                          item.certification_time,
                                        )}
                                      </small>
                                    ) : null}
                                    <>
                                      {item.status && item.status !== 1 ? (
                                        <>
                                          {item.understood !== null ? (
                                            <small
                                              className={`${
                                                item.understood === 1
                                                  ? 'text-success'
                                                  : 'text-danger'
                                              }`}
                                            >
                                              {!item.understood
                                                ? `Didn't understand`
                                                : 'Understood'}
                                            </small>
                                          ) : null}
                                          {item.understood !== null &&
                                            item.understood === 0 &&
                                            item.feedback && (
                                              <small>
                                                Reason: {item.feedback}
                                              </small>
                                            )}
                                        </>
                                      ) : null}
                                    </>
                                  </div>
                                  <div className='small-dropdown ml-1'>
                                    {employeeReport.selectedEmployeeTab ===
                                      'active' &&
                                    !isDropdownEmpty &&
                                    user.id !== employeeReport.user.id ? (
                                      <div>
                                        <Dropdown
                                          {...item}
                                          {...employeeReport}
                                          setModalHandler={setModalHandler}
                                          language={language}
                                          user={user}
                                        />
                                      </div>
                                    ) : null}
                                  </div>
                                  {isExempt ? (
                                    <button
                                      className='btn btn-info employee-button ml-1'
                                      onClick={() =>
                                        dispatch(toggleReasonOverlay(item))
                                      }
                                    >
                                      {language?.manager_report
                                        ? language.manager_report
                                            .view_exempt_reason
                                        : null}
                                    </button>
                                  ) : null}
                                </div>
                                <div className='grade-status-wrapper'>
                                  {item.waiting_for_approval ? (
                                    <span style={{ fontStyle: 'italic' }}>
                                      {language?.manager_report
                                        ? language.manager_report
                                            .waiting_for_approval
                                        : 'Waiting for approval'}
                                    </span>
                                  ) : null}
                                  {item.checklist_passed &&
                                  item.checklist_passed === -1 ? (
                                    <span className='mr-2'>
                                      <mark>
                                        <em>
                                          {language?.manager_report &&
                                          language.manager_report
                                            .checklist_failed
                                            ? language.manager_report
                                                .checklist_failed
                                            : 'Checklist Failed'}
                                        </em>
                                      </mark>
                                    </span>
                                  ) : null}
                                  <span className='grade-status'>
                                    {(() => {
                                      const userProgress =
                                        employeeReport.userProgress.find(
                                          (progressItem) =>
                                            progressItem.course_id === item.id,
                                        )

                                      if (userProgress) {
                                        item['certifyTime'] =
                                          userProgress.certify_time
                                        if (userProgress.equivalent) {
                                          item['equivalent'] =
                                            userProgress.equivalent
                                        }
                                      }

                                      switch (item.status) {
                                        case 0:
                                          return language?.manager_report
                                            ? language.manager_report
                                                .no_activity
                                            : null
                                        case 1:
                                          if (
                                            !item.has_quiz &&
                                            !item.has_checklist
                                          ) {
                                            return (
                                              <label
                                                style={{
                                                  color: getStatusColorReport(
                                                    item.status,
                                                    courseConfig,
                                                    item.past_due,
                                                  ),
                                                }}
                                              >
                                                {getLabelText(
                                                  'In Progress',
                                                  //   language
                                                )}
                                              </label>
                                            )
                                          }
                                          if (item.has_quiz) {
                                            return (
                                              <label
                                                style={{
                                                  color: getStatusColorReport(
                                                    item.status,
                                                    courseConfig,
                                                    item.past_due,
                                                  ),
                                                }}
                                              >
                                                {getLabelText(
                                                  'In Progress',
                                                  //   language
                                                )}
                                              </label>
                                            )
                                          } else if (item.has_checklist) {
                                            return (
                                              <ChecklistButton
                                                {...item}
                                                pathname={props.pathname}
                                                userId={
                                                  props.match.params.userId
                                                }
                                                language={language}
                                              />
                                            )
                                          } else {
                                            return (
                                              <label
                                                className='validation-label'
                                                style={{
                                                  color: getStatusColorReport(
                                                    item.status,
                                                    courseConfig,
                                                    item.past_due,
                                                  ),
                                                }}
                                              >
                                                {getLabelText(
                                                  'Practice at Station',
                                                  //   language
                                                )}
                                              </label>
                                            )
                                          }
                                        case 3:
                                          if (item.has_checklist) {
                                            return (
                                              <ChecklistButton
                                                {...item}
                                                pathname={
                                                  employeeReport.pathname
                                                }
                                                userId={employeeReport.user.id}
                                                language={language}
                                              />
                                            )
                                          } else {
                                            return (
                                              <label
                                                className='validation-label'
                                                style={{
                                                  color: getStatusColorReport(
                                                    item.status,
                                                    courseConfig,
                                                    item.past_due,
                                                  ),
                                                }}
                                              >
                                                {getLabelText(
                                                  'Practice at Station',
                                                  //   language
                                                )}
                                              </label>
                                            )
                                          }
                                        case 4:
                                          return (
                                            <div className='d-flex align-items-center mt-2'>
                                              {item.has_checklist &&
                                              employeeReport.selectedEmployeeTab ===
                                                'active' ? (
                                                <ChecklistButton
                                                  {...item}
                                                  pathname={props.pathname}
                                                  userId={
                                                    employeeReport.user.id
                                                  }
                                                  language={language}
                                                />
                                              ) : null}
                                              <div className='d-flex flex-column ml-3'>
                                                <div>
                                                  {item.equivalent ? (
                                                    <Tooltip
                                                      placement='top'
                                                      mouseEnterDelay={0.1}
                                                      mouseLeaveDelay={0}
                                                      trigger={[
                                                        'click',
                                                        'hover',
                                                      ]}
                                                      overlay={
                                                        <span>
                                                          {item &&
                                                          item.equivalent
                                                            ? `${
                                                                language?.groups
                                                                  ? language
                                                                      .groups
                                                                      .equivalent_to
                                                                  : null
                                                              }: ${
                                                                item.equivalent
                                                              }`
                                                            : ''}
                                                        </span>
                                                      }
                                                    >
                                                      <label
                                                        style={{
                                                          color:
                                                            getStatusColorReport(
                                                              item.status,
                                                              courseConfig,
                                                              item.past_due,
                                                            ),
                                                        }}
                                                        className='checklist-completed-label'
                                                      >
                                                        {item.equivalent
                                                          ? language?.groups
                                                            ? language.groups
                                                                .equivalent
                                                            : null
                                                          : null}{' '}
                                                        {getLabelText(
                                                          'Certified',
                                                          //   language
                                                        )}
                                                      </label>
                                                    </Tooltip>
                                                  ) : (
                                                    <label
                                                      style={{
                                                        color:
                                                          getStatusColorReport(
                                                            item.status,
                                                            courseConfig,
                                                            item.past_due,
                                                          ),
                                                      }}
                                                      className='checklist-completed-label h6'
                                                    >
                                                      {getLabelText(
                                                        'Certified',
                                                        // language
                                                      )}
                                                    </label>
                                                  )}

                                                  {courseConfig.enableCourseGeneratingCertificate ===
                                                  1 ? (
                                                    <CertificatetButton
                                                      {...employeeReport}
                                                      userId={
                                                        employeeReport.user.id
                                                      }
                                                      course={item}
                                                      setShowCertificate={() =>
                                                        dispatch(
                                                          setShowCertificate(),
                                                        )
                                                      }
                                                    />
                                                  ) : null}
                                                </div>
                                                <p className='certify-time text-sm'>
                                                  {item.certify_time &&
                                                    moment(
                                                      item.certify_time,
                                                    ).format(
                                                      'YYYY-MM-DD HH:mm',
                                                    )}
                                                </p>
                                              </div>
                                            </div>
                                          )
                                        case 6:
                                          return (
                                            <p style={{ color: '#ac7ec2' }}>
                                              Quiz Pending
                                              <FontAwesomeIcon
                                                className='ml-2'
                                                icon={faClock}
                                              />{' '}
                                            </p>
                                          )
                                        default:
                                          return language?.manager_report
                                            ? language.manager_report
                                                .not_completed
                                            : null
                                      }
                                    })()}
                                  </span>
                                </div>
                              </div>
                              {/* <div> */}
                              <div className='individual-course-progressbar'>
                                <div
                                  className='individual-course-progress'
                                  style={{
                                    width: item.status > 0 ? '100%' : '0%',
                                  }}
                                ></div>
                              </div>
                              {/* </div> */}
                              <div className='row justify-content-between'>
                                {/* <div className="col-6"> */}
                                {/* {courseConfig.enableKnowledgeQuestions ===
                                1 ? ( */}
                                <div className='col-6 quiz-title'>
                                  <span>
                                    {language?.manager_report
                                      ? language.manager_report
                                          .knowledge_questions
                                      : null}
                                  </span>
                                  {/* </div> */}
                                  {/* ) : null} */}
                                </div>
                                <div className='col-6 quiz-status'>
                                  {item.has_quiz ? (
                                    <span
                                      style={{
                                        color: item.status === 2,
                                        // && courseConfig.quizFailed,
                                      }}
                                      className={
                                        item.status < 3 && item.past_due
                                          ? 'past-due-status'
                                          : ''
                                      }
                                    >
                                      <>
                                        {item.status !== 6 && (
                                          <>
                                            {item.status < 3 &&
                                            item.status !== 6 &&
                                            item.past_due
                                              ? 'Past Due'
                                              : item.status > 2
                                                ? language?.manager_report
                                                  ? language.manager_report
                                                      .quiz_passed +
                                                    ' :' +
                                                    percentageQuiz(
                                                      item.user_submission &&
                                                        item.user_submission
                                                          .quiz_score,
                                                      item.user_submission &&
                                                        item.user_submission
                                                          .quizSubmission &&
                                                        item.user_submission
                                                          .quizSubmission,
                                                    ) +
                                                    ' %'
                                                  : null
                                                : item.status === 2
                                                  ? 'Quiz Failed' +
                                                    ' : ' +
                                                    percentageQuiz(
                                                      item.user_submission &&
                                                        item.user_submission
                                                          .quiz_score,
                                                      item.user_submission &&
                                                        item.user_submission
                                                          .quizSubmission,
                                                    ) +
                                                    ' %'
                                                  : language?.manager_report
                                                    ? language.manager_report
                                                        .not_submitted
                                                    : null}
                                          </>
                                        )}
                                      </>
                                    </span>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                          // </div>
                        )
                      })}
                  {employeeReport.selectedEmployeeTab === 'homework' ? (
                    <HomeworkTab {...employeeReport} />
                  ) : null}
                </div>
              )}
            </div>
          </Card>
        </div>
        {employeeReport.certificateShowing ? (
          <Certificate
            certificateShowing={employeeReport.certificateShowing}
            employee={employeeReport.user}
            course={employeeReport.selectedCourse}
            setHideCertificate={() => dispatch(setHideCertificate())}
            logoUrl={theme?.logo?.url}
            navLogo={theme?.navlogo}
          />
        ) : null}
        {employeeReport.isShowingReason ? (
          <ExemptReason
            {...employeeReport}
            isShowing={employeeReport.isShowingReason}
            setModalHandler={setModalHandler}
            language={language}
          />
        ) : null}

        {employeeReport.isShowingSubmission &&
        employeeReport.currentSubmission ? (
          <Submission
            submission={employeeReport.currentSubmission}
            language={language}
            isShowing={employeeReport.isShowingSubmission}
            setModalHandler={setModalHandler}
            setHideSubmissionData={setHideSubmissionData}
            {...employeeReport}
          />
        ) : null}
        {props.children}
      </Container>
      <Route
        exact
        path={`/manager-reports/employee/:userId/checklist`}
        render={(routeProps) => (
          <Checklist
            {...props}
            {...routeProps}
            userId={employeeReport.user.id}
            language={language}
            {...checklistActions}
            dispatch={dispatch}
          />
        )}
      />
    </>
  )
}
